const list = [
  {
    text: 'New & Now',
    url: '/shop/fashion-lookbooks-videos-style-guide?id=13668',
  },
  {
    text: 'Women',
    url: '/shop/womens-apparel/all-women?id=1003340',
  },
  {
    text: 'Beauty',
    url: '/shop/makeup-perfume-beauty/shop-all-beauty?id=1047059',
  },
  {
    text: 'Shoes',
    url: '/shop/womens-designer-shoes/all-fashion-shoes?id=17411',
  },
  {
    text: 'Handbags',
    url: '/shop/handbags/womens-handbags-purses?id=17316',
  },
  {
    text: 'Jewelry & Accessories',
    url: '/shop/jewelry-accessories/all-jewelry-accessories?id=1003593',
  },
  {
    text: 'Men',
    url: '/shop/all-men?id=1003601',
  },
  {
    text: 'Kids',
    url: '/shop/kids/all-kids?id=1003623',
  },
  {
    text: 'Home',
    url: '/shop/all-home?id=1003615',
  },
  {
    text: 'Sale',
    url: '/shop/sale/sale-and-clearance?id=1003304',
  },
  {
    text: 'Gifts',
    url: '/shop/gifts?id=3948',
  },
  {
    text: 'Designers',
    url: '/shop/all-designers?id=1001351',
  },
  {
    text: 'Registry',
    url: '/shop/registry/shop-all-registry-items?id=1224372',
  },
];

export default list;
